import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "../redux/feature/order";

export const store = configureStore({
  reducer: {
    order: orderReducer,
  },
});

export default store;
